import { IUsageItemResponse, IUsageResponse } from "./@types/quotausage";

export const getQuotaUsageIcon = (
  isExceeded?: boolean,
  isWarning?: boolean
): string => {
  if (isExceeded) return "pie-chart-danger";
  if (isWarning) return "pie-chart-warning";

  return "pie-chart";
};

export const isAnyUsageQuotaNearLimit = (
  usageData: IUsageResponse
): boolean => {
  return Object.values(usageData).some(usageRange =>
    usageRange.some(
      (usageItem: IUsageItemResponse) =>
        usageItem.limit > 0 &&
        usageItem.usage >= usageItem.limit * 0.8 &&
        usageItem.usage < usageItem.limit
    )
  );
};
